import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-navy text-text-light py-24 px-4 relative border-y border-copper/20" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        <FadeIn className="text-center mb-16" data-id="element-176">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-navy-light border border-copper/30 mb-6" data-id="element-177">
            <ClockIcon className="w-8 h-8 text-copper" data-id="element-178" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-cream mb-4" data-id="element-179">
            The Clock Is Ticking
          </h2>
          <div className="w-24 h-px bg-copper mx-auto opacity-50" data-id="element-180" />
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl font-body leading-relaxed text-cream/80" data-id="element-181">
          <FadeIn delay={0.2} data-id="element-182">
            <p data-id="element-183">
              The "clock" on an inherited house is brutal. For every month you
              spend "trying to figure it out," the estate loses{' '}
              <strong className="text-copper font-semibold" data-id="element-184">
                thousands in holding costs
              </strong>
              . Utility bills, vacant home insurance, and property taxes eat
              your equity while you're busy arguing with siblings or feeling
              paralyzed by the sheer volume of stuff in the garage.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-185">
            <p data-id="element-186">
              Worse, banks are cold machines. They don't have hearts; they have{' '}
              <strong className="text-copper font-semibold" data-id="element-187">
                automated foreclosure systems
              </strong>
              . If you don't speak their specific language today, they will
              treat you like a stranger and auction the property right out from
              under the family legacy.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}